// extracted by mini-css-extract-plugin
module.exports = {"widgetDialog":"MessagesWidget_widgetDialog__35Pap","widget":"MessagesWidget_widget__2RAW2","scroller":"MessagesWidget_scroller__1PsBW","noData":"MessagesWidget_noData__2cecX"};